import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { useLocation } from 'react-router-dom';

function Breadcrumbs() {
    const location = useLocation();
    const pathSetting = () => {
        if (location.pathname === '/home/search'){
            return {parent: "Video Finder", child: "Search"}
        }
        if (location.pathname === '/home/replace-search'){
            return {parent: "Video Finder", child: "Replace - Search"}
        }
        if (location.pathname === '/home/videos'){
            return {parent: "Video Finder", child: "Videos"}
        }
        if (location.pathname === '/home/settings'){
            return {parent: "Video Finder", child: "Settings"}
        }
        if (location.pathname === '/home/course-content-all'){
            return {parent: "Course Content", child: "All"}
        }
        if (location.pathname === '/home/course-contents-video'){
            return {parent: "Course Content", child: "Video"}
        }
        if (location.pathname === '/home/course-contents-web'){
            return {parent: "Course Content", child: "Web"}
        }
        if (location.pathname === '/home/assignment-content-all'){
            return {parent: "Assignment Content", child: "All"}
        }
        if (location.pathname === '/home/assignment-content-video'){
            return {parent: "Assignment Content", child: "Video"}
        }
        if (location.pathname === '/home/assignment-content-web'){
            return {parent: "Assignment Content", child: "Web"}
        }
        if (location.pathname === '/home/summary-generation'){
            return {parent: "Video Finder", child: "Summary Generation"}
        }
        if (location.pathname === '/home/scribe-content-generate'){
            return {parent: "Scribe Bot", child: "Generate"}
        }
        if (location.pathname === '/home/scribe-contents'){
            return {parent: "Scribe Bot", child: "Generated Contents"}
        } 
        if (location.pathname === '/home/scribe-settings'){
            return {parent: "Scribe Bot", child: "Settings"}
        } 
    }
    let pathObj = pathSetting()
    return (
        <Breadcrumb>
            <Breadcrumb.Item href="/home">Home</Breadcrumb.Item>
            <Breadcrumb.Item className='breadcrumb-no-link'>{pathObj.parent}</Breadcrumb.Item>
            <Breadcrumb.Item className='breadcrumb-no-link' active>{pathObj.child}</Breadcrumb.Item>
        </Breadcrumb>
    );
}

export default Breadcrumbs;